import React, { useState } from 'react';
import Popup from '../Modals/Popup';

export default function EditNotes({ button, leadData,addNote }) {
  const [show, setShow] = useState(false);
  const [content, setContent] = useState(leadData && leadData.notes.find((note) => note.title == "Appointment Details")?.note);


  const openPopup = () => {
    setShow(true);
  };

  const closePopup = () => {
    setShow(false);
  };

  const updateNotes = () => {
    const values = {'id':leadData.id,'title':"Appointment Details",'subtitle':'','note':content};

    addNote(values);

    closePopup();
  }

  

  return (
    <>
      {button && <div onClick={openPopup}>{button}</div>}
      <Popup action={show ? 'open' : ''} button={button}>
        <h2 className="headingedit mb-1">Notes</h2>
        <textarea
          className="editnote-textarea"
          placeholder="Notes..."
          value={content}
          onChange={(e) => setContent(e.target.value)}
          rows={3}
        ></textarea>
        <button onClick={updateNotes} className="editbtn">
          Update
        </button>
      </Popup>
    </>
  );
}
